import { useEffect, useState } from "react";
import TextInput, { TextInputProps } from "../TextInput/TextInput";
import { checkValidity } from "../../../utils/inputValidityChecker";
import styles from "./TextInputSearch.module.scss";



export type TextInputSearchProps =  TextInputProps &{

    timeout?: number
    sendQuery?: (query: string | null) => void
    setIsLoading?: (isLoading: boolean) => void
    valueInit?: string | null
    onChangeCallback?: (query: string) => void
}

export default function TextInputSearch({timeout = 1000, sendQuery, setIsLoading, onChange: onChangeRaw, valueInit,value, onChangeCallback, ...rest}: TextInputSearchProps) {
    const [query, setQuery] = useState<string | null>(valueInit || null);

    const [readyToSearch, setReadyToSearch] = useState(false);
  
    const minLenghtQuery = 0;
  
    useEffect(() => {
      if (valueInit) {
        setQuery(valueInit);
        sendQuery && sendQuery(query);
      }
    }, [valueInit]); // eslint-disable-line

    useEffect(() => {
      if (readyToSearch && sendQuery) {
        sendQuery(query);
        // Désactiver le loader seulement si la requête est vide
        if (!query || String(query).trim().length === 0) {
          setIsLoading && setIsLoading(false);
        }
      }
    }, [readyToSearch]); // eslint-disable-line
  
    const handleClear = () => {
      setQuery("");
      setReadyToSearch(false);
      onChangeCallback && onChangeCallback("");
      sendQuery && sendQuery(null);
      setIsLoading && setIsLoading(false);
      // Annuler les timeouts en cours
      setReadyToSearch(false);
    };
  
    const onSetQuery = (query: string) => {
      setQuery(query);
      
      // Appeler onChangeCallback en premier pour activer le loader immédiatement
      onChangeCallback && onChangeCallback(query);
      

      if (query !== "" &&!checkValidity(query, "text-not-empty")) {
        return;
      }
  
      // Activer le loader immédiatement dès qu'il y a du texte (via setIsLoading aussi pour compatibilité)
      const hasText = String(query).trim().length > 0;
      if (setIsLoading) {
        setIsLoading(hasText);
      }
  
      if (String(query).length >= minLenghtQuery) {
        setReadyToSearch(false);
        setTimeout(() => {
          setReadyToSearch(true);
        }, timeout);
      }
  
      if (readyToSearch) {
        setReadyToSearch(false);
  
        setTimeout(() => {
          setReadyToSearch(true);
          // Le loader sera désactivé quand la requête sera envoyée dans useEffect
        }, timeout);
      }
    };
    
  const hasValue = query && String(query).trim().length > 0;
    
  return (
    <div className={styles.searchContainer}>
      <TextInput {...rest} onChange={(e) => { onSetQuery(e.target.value)}} value={query}/>
      {hasValue && (
        <button
          type="button"
          className={styles.clearButton}
          onClick={handleClear}
          aria-label="Effacer la recherche"
        >
          ×
        </button>
      )}
    </div>
  )
}
